
import { defineComponent, ref, watch } from 'vue'
import { isVideo, timeToNumber } from './utils'

export default defineComponent({
  name: 'Preview',
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  setup(props) {

    const limit = ref(0)
    const material = ref<any[]>([])
    const visible = ref(false)
    const playList: any[] = []
    let timer: any = null
    let index = 0;

    const handlePreview = () => {
      visible.value = true
      document.body.style.overflow = 'hidden'
      start()
    }

    const start = () => {
      if (index > playList.length - 1) {
        index = 0
      }
      const { cards, duration } = playList[index]
      material.value = cards.map((item: any) => ({ ...item, url: `${item.url}?t=${new Date().getTime()}` }))
      console.log('material.value: ', material.value);
      console.log('cards: ', cards);
      limit.value = cards.length
      timer = setTimeout(() => {
        index++
        start()
      }, duration * 1000)
    }

    const handleClose = (event: MouseEvent) => {
      const el = event.target as HTMLElement
      if (el.classList.contains('container')) {
        index = 0
        clearTimeout(timer)
        visible.value = false
        document.body.style.overflow = 'auto'
      }
    }

    watch(props, () => {
      playList.length = 0
      const periods = props.data.period || []
      periods.forEach((period: any) => {
        const material = period.material || []
        material.forEach((item: any) => {
          playList.push({ cards: item.cards, duration: timeToNumber(item.duration) })
        })
      })
    }, { immediate: true })

    return {
      limit,
      material,
      visible,
      handleClose,
      handlePreview,
      isVideo
    }
  }
})

